<template>
  <div class="batchDestroyPlants">
    <vs-popup id="batch-destroy-popup" title="Batch Destroy Plants" :active.sync="isActive">
      <form ref="destroyBatchPlant">
        <div class="vx-row mb-5">
          <div class="vx-col w-full">
            <div class="mb-2 w-full">
              <label for="Count">Count *</label>
              <vs-input type="number" class="w-full" v-model="form.count" placeholder="Enter plant count" name="Plant Count" v-validate="'required'" />
              <span class="text-danger text-sm" v-show="errors.has('Plant Count')">{{ errors.first('Plant Count') }}</span>
            </div>
            <div class="mb-2 w-full">
              <label for="Reason">Reason</label>
              <vs-input class="w-full" v-model="form.reason" placeholder="Enter Reason" name="Reason" />
              <span class="text-danger text-sm" v-show="errors.has('Reason')">{{ errors.first('Reason') }}</span>
            </div>
            <div class="mb-2 w-full">
              <label for="ActualDate">Actual Date *</label>
              <date-picker
                :appendToBody="false"
                label-placeholder="Actual Date"
                v-model="form.actualDate"
                placeholder="MM-DD-YYYY"
                format="MM-DD-YYYY"
                valueType="format"
                class="w-full"
                name="Actual Date"
                v-validate="'required'"
              />

              <span class="text-danger text-sm" v-show="errors.has('Actual Date')">{{ errors.first('Actual Date') }}</span>
            </div>
          </div>
        </div>
        <hr />
        <div class="vx-row justify-center mt-5">
          <vs-button class="mr-5" @click="destroyBatchPlants()" color="primary" type="relief">Save</vs-button>
          <vs-button @click="isActive = false" color="danger" type="relief">Close</vs-button>
        </div>
      </form>
    </vs-popup>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import moment from 'moment'

export default {
  name: 'BatchDestroyPlants',

  components: {
    DatePicker
  },

  props: {
    isDestroyPopup: Boolean,
    batchId: Number
  },

  data() {
    return {
      form: {
        count: null,
        reason: null,
        actualDate: moment().format('MM-DD-YYYY')
      },
      loading: false
    }
  },

  computed: {
    isActive: {
      get() {
        return this.isDestroyPopup
      },
      set(val) {
        this.$emit('update:isDestroyPopup', val)
      }
    }
  },

  methods: {
    ...mapActions('batch', ['destroyPlants']),

    async destroyBatchPlants() {
      if (!(await this.$validator.validate())) {
        this.$vs.notify({
          title: 'Error',
          text: 'Please Fill The Form First',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
        return
      }

      this.loading = true
      try {
        const { message } = await this.destroyPlants({
          batchId: this.batchId,
          data: { ...this.form }
        })

        this.$emit('update:isDestroyPopup', false)
        this.$emit('done')

        this.loading = false
        this.$vs.notify({
          title: 'Success',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })
      } catch ({ message }) {
        this.loading = false
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
    }
  },

  watch: {
    loading() {
      if (this.loading) {
        this.$vs.loading({
          container: '#batch-destroy-popup',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#batch-destroy-popup > .con-vs-loading')
      }
    },

    isActive() {
      if (!this.isActive) {
        //clear the form
        delete this.form.count
        delete this.form.reason
        delete this.form.actualDate

        this.errors.clear()
      }
    }
  },

  beforeRouteLeave(_, __, next) {
    this.$emit('update:isDestroyPopup', false)
    next()
  }
}
</script>

<style lang="scss" scoped>
#batch-destroy-popup {
  .vs-popup {
    width: calc(100% - 30%) !important;
    .vdp-datepicker {
      position: unset;
    }
  }
}
</style>
